export const connectorPowerTypes = [
  'AC_1_PHASE',
  'AC_2_PHASE',
  'AC_2_PHASE_SPLIT',
  'AC_3_PHASE',
  'DC',
] as const;
export type ConnectorPowerType = (typeof connectorPowerTypes)[number];
